import * as React from 'react';

interface InfoSectionProps {
  title: string;
  description: string;
}

export const CryptoGuide: React.FC = () => {
  const cryptoSections: InfoSectionProps[] = [
    {
      title: 'Compliance Automation',
      description: 'Our platform handles KYC/AML, accreditation, and transfer restrictions automatically through programmable compliance.',
    },
    {
      title: 'Liquidity Solutions',
      description: 'Enable secondary trading opportunities for your LPs within regulatory frameworks, reducing lock-up frustrations.',
    },
    {
      title: 'Global Capital Access',
      description: 'Reach international investors efficiently while maintaining full regulatory compliance across jurisdictions.',
    },
    {
      title: 'Capital Efficiency',
      description: 'Reduce minimum check sizes and administrative costs with fractional ownership and automated treasury management.',
    },
    {
      title: 'Investor Experience',
      description: 'Provide your LPs with real-time portfolio transparency, automated distributions, and digital compliance.',
    },
  ];

  const InfoSection: React.FC<InfoSectionProps> = ({ title, description }) => {
    return (
      <article className="flex flex-col justify-center mt-10 w-full max-md:max-w-full">
        <h2 className="text-2xl font-semibold tracking-normal leading-none">
          {title}
        </h2>
        <p className="mt-2 text-xl leading-6 max-md:max-w-full">
          {description}
        </p>
      </article>
    );
  };

  return (
    <main className="flex gap-10 text-slate-900">
      <section className="flex flex-col flex-1 shrink w-full basis-0 min-w-[240px] max-md:max-w-full">
        <h1 className="text-5xl font-extrabold tracking-tight leading-none max-md:max-w-full max-md:text-4xl">
          Fund Tokenization Benefits
        </h1>
        <div className="flex flex-col mt-10 w-full max-md:max-w-full">
          {cryptoSections.map((section, index) => (
            <InfoSection
              key={index}
              title={section.title}
              description={section.description}
            />
          ))}
        </div>
      </section>
    </main>
  );
};
